import { BcAlert } from '@britishcouncil/react-solas-ors3';

export const ActivatonFailed = () => {
  return (
    <BcAlert type="danger" title="Oooops">
      <p>Account activation failed. Please, try again.</p>
    </BcAlert>
  );
};

export const OnlyMigrationFailed = () => {
  return (
    <BcAlert type="danger" title="Oooops">
      <p>Account migration failed. Please, try again.</p>
    </BcAlert>
  );
};
